"use client";

import {
  DashboardHeader,
  ActionCardsSection,
  ProgressSection,
  HeroSection,
  EarnSection,
  ProgressEarnSection
} from "./_landing/components";
import { useConnection } from "@/contexts/connection-context";
import { useReferral } from "@/hooks/useReferral";
import { ReferralModal } from "@/components/ReferralModal";
import { useGetCampaignUser, useConsumeQuestsArgs } from "@/hooks/challenges";
import { CAMPAIGN_ID, CAMPAIGN_GROUP_ID } from "@/config/campaign";

export default function Home() {
  const { isConnected, isAuthenticated, walletAddress } = useConnection();
  
  // Referral system
  const {
    isOpen: isReferralModalOpen,
    onClose: onReferralModalClose,
    onReject: onReferralReject,
    referralCode,
    applyReferral,
    isLoading: isReferralLoading,
    setIsOpen: setIsReferralModalOpen,
  } = useReferral(CAMPAIGN_ID, CAMPAIGN_GROUP_ID, walletAddress, isAuthenticated);

  // Get campaign user data for referral info
  const { data: campaignUser } = useGetCampaignUser(CAMPAIGN_ID, CAMPAIGN_GROUP_ID, isAuthenticated);

  // Handle Discord OAuth callbacks and other quest-related URL parameters
  useConsumeQuestsArgs(CAMPAIGN_ID, CAMPAIGN_GROUP_ID);


  if (!isConnected || !isAuthenticated) {
    return (
      <>
        <HeroSection />
        <EarnSection />
        <ProgressEarnSection />
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        <DashboardHeader user={campaignUser} walletAddress={walletAddress} />
        <ActionCardsSection user={campaignUser} />
        {/* <ProgressSection /> */}
      </div>
      
      {/* Referral Modal */}
      <ReferralModal
        isOpen={isReferralModalOpen}
        onClose={onReferralModalClose}
        onApply={applyReferral}
        referralCode={referralCode || ""}
        isLoading={isReferralLoading}
        hasActiveReferral={campaignUser?.referralData?.referredBy !== null}
        address={walletAddress || ""}
      />
    </div>
  );
}
